"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveStatusIndicator = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var Flex_1 = __importDefault(require("@atg/icf-react-components/components/Flex"));
var Text_1 = __importDefault(require("@atg/icf-react-components/components/Text"));
var react_jss_1 = require("react-jss");
var Contexts_1 = require("../Contexts");
var Ioc_1 = require("../utilities/Ioc");
var useLiveStatusIndicatorStyles = (0, react_jss_1.createUseStyles)({
    "@keyframes fadeIn": {
        "0%": { opacity: 0 },
        "10%, 90%": { opacity: 1 },
        "100%": { opacity: 0 },
    },
    container: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        justifyContent: "space-between",
        alignItems: "center",
        alignContent: "center",
        position: "absolute",
        top: "7px",
        insetInlineStart: "3.25px",
        opacity: 0,
        padding: "0px 3px",
        animationName: "$fadeIn",
        animationIterationCount: 1,
        animationDuration: "5s",
    },
});
// NOTE: LiveStatusIndicator is derived from hybrid.client/.../VideoInfo.js
// Any changes here, might make sense there, or in a shared component.
var LiveStatusIndicator = function (_a) {
    var _b = __read((0, Ioc_1.useContexts)(Contexts_1.ITranslationServiceContext), 1), translate = _b[0].translate;
    var classes = useLiveStatusIndicatorStyles();
    return ((0, jsx_runtime_1.jsx)("div", { className: classes.container, children: (0, jsx_runtime_1.jsxs)(Flex_1.default, { background: "textOnLight", padding: "3 5", borderRadius: 4, backgroundOpacity: 70, direction: "row", gap: 4, alignItems: "center", children: [(0, jsx_runtime_1.jsx)(Flex_1.default, { width: "7px", height: "7px", background: "success", borderRadius: 50, alignItems: "center" }), (0, jsx_runtime_1.jsx)(Text_1.default, { fontSize: 11, color: "textOnDark", fontWeight: 800, letterSpacing: 0, lineHeight: 1, textTransform: "uppercase", children: translate("search.live") })] }) }));
};
exports.LiveStatusIndicator = LiveStatusIndicator;
//# sourceMappingURL=LiveStatusIndicator.js.map